/* Spanish catalog mirroring locale-fr-part2.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'fi.recheck': 'Ya lo he confirmado',
  'fi.stillUnverified': 'La dirección sigue sin confirmarse. Revisa tu bandeja de entrada y la carpeta de spam.',
  'fi.decline': 'Rechazar',
  'fi.declined': 'La invitación fue rechazada.',
  'set.firm.title': 'Despacho contable',
  'set.firm.sub': 'El despacho solo accede a tu contabilidad una vez que aceptas y pierde el acceso en cuanto pones fin al acuerdo.',
  'set.firm.none': 'Ningún despacho contable tiene acceso a esta empresa ni lo ha solicitado.',
  'set.firm.pending': 'Esperando tu respuesta',
  'set.firm.active': 'Tiene acceso',
  'set.firm.end': 'Finalizar el acuerdo',
  'set.firm.endConfirm': '¿Finalizar el acuerdo con {firm}? Sus compañeros pierden inmediatamente el acceso a tu contabilidad.',
  'set.firm.ended': 'El acuerdo ha finalizado y el acceso se ha retirado.',
  'set.firm.onlyManagers': 'Solo el propietario y los administradores pueden responder a una solicitud.',
  'rf.create.title': 'Crear despacho contable',
  'rf.create.eyebrow': 'Despacho contable',
  'rf.create.readyBody': 'El despacho está creado y eres su propietario. Ahora invita a tus compañeros y conecta a tus clientes.',
  'rf.create.openSurface': 'Abrir el espacio del despacho',
  'rf.create.body': 'El despacho se busca en el Enhetsregisteret. Te conviertes en su propietario y después puedes invitar a compañeros.',
  'rf.create.orgNumber': 'Número de organización',
  'rf.create.hintDigits': 'Nueve dígitos. El despacho debe estar registrado en el Enhetsregisteret.',
  'rf.create.hintReady': 'El número se busca en el Enhetsregisteret al crear el despacho.',
  'rf.create.hintDemo': 'La cuenta de demostración puede usar un número inventado. Ponle un nombre al despacho más abajo.',
  'rf.create.firmName': 'Nombre del despacho',
  'rf.create.nameRequired': 'No se encontró la empresa en el Enhetsregisteret. Introduce el nombre del despacho para continuar.',
  'rf.create.unverifiedNote': 'El despacho se crea sin consultar el registro y se marca como no verificado. Debe verificarse antes de que los despachos reales entren en funcionamiento.',
  'rf.create.demoNote': 'La cuenta de demostración define el nombre por sí misma. Las cuentas normales lo obtienen del Enhetsregisteret.',
  'rf.create.submit': 'Crear despacho',
  'rf.create.working': 'Creando …',
  'rf.create.done': 'El despacho contable se ha creado',
  'rf.create.note': 'La consulta confirma que la empresa existe. No comprueba si puedes actuar en su nombre.',
  'rf.member.title': 'Cargo',
  'rf.member.email': 'Correo electrónico',
  'rf.member.person': 'Persona',
  'rf.member.rights': 'Permisos',
  'rf.member.inviteTitle': 'Invitar a un compañero',
  'rf.member.invite': 'Enviar invitación',
  'rf.member.inviting': 'Enviando …',
  'rf.member.invited': 'Invitación enviada',
  'rf.member.inviteMailFailed': 'La invitación se creó, pero no se pudo enviar el correo.',
  'rf.member.listTitle': 'Equipo',
  'rf.member.none': 'Aún no hay compañeros.',
  'rf.member.updated': 'El cargo se ha cambiado',
  'rf.member.remove': 'Quitar acceso',
  'rf.member.removed': 'Acceso retirado',
  'rf.member.removedWithClients': 'Acceso retirado, incluido en {count} clientes.',
  'rf.member.removeConfirm': '¿Quitar el acceso de {name}? Todo el acceso a clientes que el despacho concedió a esta persona se retira al mismo tiempo.',
  'rf.member.removeNote': 'Al quitar a un compañero también se retira todo el acceso a clientes que el despacho le concedió, en todos los clientes y en una sola operación.',
  'rf.member.ownerRights': 'Propietario del despacho',
  'rf.member.canControl': 'Puede controlar',
  'rf.nav.backToApp': 'Volver a mi contabilidad',
  'rf.nav.back': 'Volver',
  'app.nobusiness.openFirm': 'Abrir el despacho contable',
  'rf.tab.close': 'Cerrar pestaña',
  'rf.tab.assignFirst': 'Todavía no hay nadie asignado a este encargo. El acceso a la contabilidad sigue a la asignación: asigna a alguien al encargo en Clientes.',
  'rf.tab.assignNeeded': 'No estás asignado a este encargo. Pide a un administrador del despacho que te asigne.',
  'rf.soon.clients': 'La vista general de clientes se está conectando al estado del cliente que el backend calcula para cada uno.',
  'rf.soon.reconciliation': 'El espacio de conciliación está en desarrollo. El modelo de acceso y el estado del cliente en los que se basa ya están listos.',
  'rf.soon.control': 'El espacio de control llegará después de la conciliación. La regla de los cuatro ojos se aplicará en el backend cuando se lance.',
  'rf.noFirm.title': 'No eres miembro de ningún despacho contable',
  'rf.noFirm.body': 'Todavía no eres miembro de ningún despacho. Crea el tuyo más abajo o pide a un administrador del despacho que te invite: la invitación llega por correo electrónico.',
  'tc.title': 'Chat del equipo',
  'tc.rooms': 'Salas',
  'tc.dms': 'Mensajes directos',
  'tc.newRoom': 'Nueva sala',
  'tc.roomName': 'Nombre de la sala',
  'tc.roomNamePlaceholder': 'Por ej. Equipo de control',
  'tc.createRoom': 'Crear sala',
  'tc.noColleagues': 'Aún no hay más compañeros en el despacho',
  'tc.commonRoom': 'Sala común',
  'tc.room': 'Sala',
  'tc.commonSubtitle': 'Sala compartida para todo el equipo',
  'tc.roomSubtitle': 'Sala del despacho',
  'tc.dm': 'Mensaje directo',
  'tc.dmSubtitle': 'Mensaje directo',
  'tc.empty': 'Aún no hay mensajes aquí: escribe el primero.',
  'tc.placeholder': 'Escribe un mensaje…',
  'tc.send': 'Enviar',
  'tc.unknown': 'Desconocido',
  'shell.client.clients': 'Tus clientes',
  'shell.client.signOutSub': 'Cerrar la sesión en este dispositivo',
  'shell.client.signOutFailed': 'No se pudo cerrar la sesión. Inténtalo de nuevo.',
  'shell.client.none': 'Ninguna empresa',
  'shell.client.noBusinesses': 'Ninguna empresa',
  'shell.client.connecting': 'Conectando con el backend de Plumme',
  'shell.client.personalEconomy': 'Finanzas personales',
  'shell.client.accountingClient': 'Cliente contable',
  'shell.client.org': 'N.º org. {org}',
  'shell.suggest.invoices': 'Facturas',
  'shell.suggest.customers': 'Clientes',
  'shell.suggest.vouchers': 'Justificantes',
  'trial.title': 'Prueba activa',
  'trial.active': 'Tu prueba está activa.',
  'trial.dayLeft': 'Te queda {days} día.',
  'trial.daysLeft': 'Te quedan {days} días.',
  'trial.body': 'Todo funciona: aprovecha para conocer Plumme.',
  'trial.upgrade': 'Mejorar plan',
  'home.greeting': 'Te damos la bienvenida 👋',
  'home.registerSale': 'Registrar venta',
  'home.registerSaleHelp': 'Registra una venta nueva o crea una factura para un cliente. La venta se contabiliza automáticamente en la cuenta correcta.',
  'home.registerPurchase': 'Registrar compra',
  'home.registerPurchaseHelp': 'Registra una compra o sube un recibo. SuperPlumma te sugiere la cuenta y el tratamiento del IVA.',
  'home.aiHelp': 'Aquí ves todo lo que SuperPlumma y los agentes han hecho automáticamente: contabilidad, IVA, nómina y más. Apruebas con un solo toque.',
  'home.autopilot.active': 'Activo',
  'home.autopilot.followUp': 'Requiere revisión',
  'home.autopilot.disabled': 'Desactivado',
  'home.view.period': 'Periodo',
  'home.view.analysis': 'Análisis',
  'home.view.cashflow': 'Resultado neto',
  'home.viewLabel.period': 'Ingresos y gastos por mes',
  'home.viewLabel.analysis': 'Desglose de ingresos frente a gastos',
  'home.viewLabel.cashflow': 'Resultado neto por mes',
  'home.ana.ring': 'Desglose',
  'home.ana.gauge1': 'Cifras clave',
  'home.ana.gauge2': 'Cifras clave financieras',
  'home.sub.yoyArrow': 'La flecha indica la variación respecto al año pasado.',
  'home.sub.exVat': 'Todos los totales se muestran sin IVA.',
  'home.legend.in': 'Entradas',
  'home.legend.out': 'Salidas',
  'home.legend.income': 'Ingresos',
  'home.legend.cost': 'Gastos',
  'home.legend.result': 'Resultado',
  'home.legend.cashflow': 'Resultado',
  'home.selectedMonths': 'Meses seleccionados:',
  'home.reset': 'Borrar',
  'home.sumOfMonth': 'Total de {n} mes',
  'home.sumOfMonths': 'Total de {n} meses',
  'home.noPrevPeriod': 'Sin periodo anterior',
  'home.fromPrevMonth': 'respecto al mes pasado',
  'home.fromLastYear': 'respecto al año pasado',
  'home.showDistribution': 'Mostrar desglose',
  'home.noData': 'Sin datos',
  'home.donut.registeredIncome': 'Ingresos registrados',
  'home.donut.registeredCosts': 'Gastos registrados',
  'home.donut.income': 'Ingresos',
  'home.donut.costs': 'Gastos',
  'home.donut.result': 'Resultado',
  'home.donut.breakdown': '{title} — desglose',
  'home.donut.back': 'Volver',
  'home.donut.hint': 'Toca una parte del anillo o una tarjeta de KPI de abajo para ver el desglose',
  'home.health.good': 'Buena',
  'home.health.balanced': 'Equilibrada',
  'home.health.weak': 'Débil',
  'home.gauge.explain': 'Explicar esta cifra clave',
  'home.gauge.currentValue': 'Valor actual',
  'home.gauge.assessment': 'Valoración',
  'home.gauge.goodLevel': 'Buen nivel: {good}',
  'home.gauge.income': 'Ingresos',
  'home.gauge.income.info': 'Los ingresos son el total de todo lo que la empresa ha vendido en el periodo, sin IVA. Unos ingresos al alza con el tiempo te dan más margen de maniobra.',
  'home.gauge.income.good': 'Al alza con el tiempo',
  'home.gauge.costs': 'Gastos',
  'home.gauge.costs.info': 'Los gastos son los desembolsos necesarios para dirigir la empresa, sin IVA. Unos gastos menores en relación con los ingresos dan un mejor resultado.',
  'home.gauge.costs.good': 'Inferiores a los ingresos',
  'home.gauge.result': 'Resultado',
  'home.gauge.result.info': 'El resultado es lo que queda al restar los gastos de los ingresos. Un resultado positivo significa beneficio en el periodo.',
  'home.gauge.result.good': 'Positivo y estable',
  'home.gauge.liquidity': 'Liquidez',
  'home.gauge.liquidity.info': 'La liquidez muestra la capacidad de pagar facturas y deudas a corto plazo cuando vencen. Un valor más alto da un mejor colchón.',
  'home.gauge.liquidity.good': 'Por encima de 1,0x, idealmente por encima de 2,0x',
  'home.gauge.profitability': 'Rentabilidad',
  'home.gauge.profitability.info': 'La rentabilidad muestra qué parte de tus ingresos queda como resultado. Cuanto mayor es el porcentaje, más gana la empresa por unidad vendida.',
  'home.gauge.profitability.good': 'Positiva y al alza',
  'home.gauge.solidity': 'Solvencia',
  'home.gauge.solidity.info': 'La solvencia muestra qué parte de la empresa está financiada con capital propio. Una solvencia mayor hace a la empresa más robusta.',
  'home.gauge.solidity.good': 'Una proporción de capital propio creciente con el tiempo',
  'home.assistant.sub': 'Asistente contable',
  'home.assistant.intro': '¡Hola! Puedo encargarme de acciones sencillas por ti, crear facturas, registrar compras, explicar impuestos y contabilizar recibos de tu bandeja de entrada. Pregunta lo que quieras. Si quieres asesoramiento financiero, el asesor está disponible en la página Asesor IA.',
  'home.assistant.thinking': 'SuperPlumma está pensando...',
  'home.assistant.placeholder': 'Pregunta a SuperPlumma...',
  'home.assistant.noReply': 'SuperPlumma no recibió respuesta del backend.',
  'home.assistant.errorReply': 'No se pudo obtener una respuesta del asistente en este momento.',
  'home.assistant.errorToast': 'No se pudo obtener la respuesta del asistente.',
  'home.assistant.cancel': 'Cancelar',
  'home.assistant.opened': 'He abierto la página correcta con la propuesta lista para que la revises.',
  'home.assistant.openedToast': 'Flujo correcto abierto',
  'home.assistant.noAdapter': 'Esta acción aún no tiene un adaptador de Plumme.',
  'home.assistant.paymentNotConnected': 'El registro de pagos no está conectado al backend.',
  'home.assistant.paymentRegistered': 'Se ha registrado un pago de {sum} en la factura{number}.',
  'home.assistant.paymentToast': 'Pago registrado',
  'home.assistant.paymentFailed': 'No se pudo registrar el pago.',
  'home.assistant.cancelled': 'De acuerdo, no he hecho ningún cambio.',
  'home.assistant.sugg1': '¿Cuánto debo de impuestos?',
  'home.assistant.sugg2': 'Crear una factura para un cliente',
  'home.assistant.sugg3': '¿Qué es el IVA?',
  'home.action.register_payment': 'Aprobar pago',
  'home.action.create_invoice': 'Abrir borrador de factura',
  'home.action.create_other_sale': 'Abrir otra venta',
  'home.action.create_expense': 'Abrir nueva compra',
  'home.action.register_purchase': 'Abrir nueva compra',
  'home.action.create_customer': 'Guardar cliente',
  'home.action.create_supplier': 'Guardar proveedor',
  'home.action.create_product': 'Guardar producto',
  'home.action.suggest_accounting_entry': 'Abrir asiento manual',
  'home.action.create_mileage_entry': 'Abrir registro de kilometraje',
  'home.action.send_sales_document': 'Abrir facturas',
  'home.action.book_bank_lines': 'Abrir banco',
  'home.action.link_bank_receipts': 'Abrir banco',
  'home.action.annul_bank_posting': 'Abrir banco',
  'home.action.reporting_preparation': 'Abrir declaraciones',
  'home.action.default': 'Abrir flujo',
  'home.followup.title': 'Seguimiento',
  'home.followup.allClear': 'Todo está bajo control',
  'home.followup.allClearSub': 'No hay nada que seguir por ahora. Plumme te avisará cuando algo necesite atención.',
  'home.followup.next': 'Continuar',
  'home.followup.showMore': 'Mostrar más',
  'home.followup.modalTitle': 'Tareas que requieren atención',
  'home.followup.sales': 'Ventas',
  'home.followup.purchases': 'Compras',
  'home.followup.toInvoiceList': 'Ir a facturas',
  'home.followup.toVoucherList': 'Ir a justificantes',
  'home.followup.draftInvoices': 'Tienes {n} borradores de factura sin terminar.',
  'home.followup.unsentInvoices': 'Tienes {n} facturas listas pero sin enviar.',
  'home.followup.overdueInvoices': 'Tienes {n} facturas vencidas sin liquidar.',
  'home.followup.openPurchases': 'Tienes {n} facturas de proveedor sin liquidar.',
  'home.followup.missingAttachments': 'Tienes {n} compras sin recibo.',
  'home.followup.bank': 'Conciliación bancaria',
  'home.followup.toBank': 'Ir a la conciliación bancaria',
  'home.followup.missingBankStatements': 'Faltan los extractos bancarios de la cuenta operativa de {months}',
  'home.overview.sales': 'Ventas',
  'home.overview.purchases': 'Compras',
  'home.overview.outstandingSales': 'Ventas pendientes de cobro',
  'home.overview.outstandingPurchases': 'Compras pendientes de pago',
  'home.overview.salesHelp': 'Las ventas pendientes de cobro son facturas que tus clientes aún no han pagado. El verde está dentro del plazo y el ámbar está vencido: haz su seguimiento con un recordatorio.',
  'home.overview.purchasesHelp': 'Las compras pendientes de pago son facturas de proveedor que aún no has pagado. El verde está dentro del plazo y el ámbar está vencido y conviene pagarlo pronto.',
  'home.overview.importedSubledger': 'De los cuales, auxiliar importado: {amount}',
  'home.overview.inclVat': 'Los importes incluyen IVA.',
  'home.overview.helpTitle': '{what} pendientes',
  'home.overview.withinDue': 'Dentro del plazo',
  'home.overview.overdue': 'Vencidas',
  'home.overview.statusTitle': '{within} % dentro del plazo · {over} % vencidas',
  'home.deadlines.title': 'Próximos vencimientos',
  'home.deadlines.help': 'Próximos plazos de presentación: declaración de IVA, declaración de impuestos, cuentas anuales y declaración del registro de accionistas, con el estado de cada una.',
  'home.deadlines.none': 'No se encontraron vencimientos en los datos del backend.',
  'home.deadlines.seeStatus': 'Ver estado',
  'home.deadlines.helpTax': 'La declaración de impuestos reúne tu contabilidad y el cálculo de impuestos del año. Plumme te ayuda a revisar las cifras antes de presentarla.',
  'home.deadlines.helpAnnualAccounts': 'Las cuentas anuales reúnen la cuenta de resultados, el balance y las notas del ejercicio fiscal, y se presentan ante Regnskapsregisteret cuando están listas.',
  'home.deadlines.helpAnnualClosing': 'El cierre del ejercicio cierra el ejercicio fiscal con comprobaciones, distribución del resultado y los asientos de cierre necesarios.',
  'home.deadlines.helpShareholderRegister': 'La declaración del registro de accionistas (RF-1086) la presentan las sociedades de capital a más tardar el 31 de enero del año siguiente al año fiscal. Plumme no puede presentarla: esto es un recordatorio.',
  'home.deadlines.helpVat': 'La declaración de IVA informa del IVA repercutido y del IVA soportado del periodo.',
  'home.deadlines.helpFallback': 'Vencimiento de {name}. Plumme te avisa y te guía desde la vista de estado.',
  'home.deadlines.fallbackName': 'presentación',
  'home.deadlines.name.shareholderRegister': 'Declaración del registro de accionistas',
  'home.fees.title': 'Obligaciones públicas',
  'home.fees.help': 'Resumen de lo que debes ahora mismo a las autoridades: IVA, retenciones de impuestos y cotizaciones patronales. Se calcula de forma continua a partir de tu contabilidad.',
  'home.fees.none': 'No se encontraron obligaciones públicas pendientes.',
  'home.balances.title': 'Saldos',
  'home.balances.help': 'Saldos contabilizados de banco, caja y otras cuentas. Las cifras provienen del balance de comprobación, así que muestran lo que dice tu contabilidad, no lo que el banco ha logrado actualizar. Usa la rueda dentada para elegir qué cuentas mostrar o busca más en el plan de cuentas. La cuenta operativa y la de caja se pueden ocultar, pero no eliminar.',
  'home.balances.choose': 'Elegir cuentas',
  'home.balances.total': 'Total',
  'home.balances.accountFallback': 'Cuenta {code}',
  'home.balances.noneSelected': 'No hay cuentas seleccionadas.',
  'home.balances.searchPlaceholder': 'Buscar en el plan de cuentas …',
  'home.balances.noHits': 'Sin coincidencias',
  'home.balances.remove': 'Quitar de la tarjeta',
  'home.balances.saveFailed': 'No se pudo guardar la selección de cuentas.',
  'set.account': 'Cuenta',
  'set.amount': 'Importe',
  'set.page': 'Página',
  'set.debit': 'Débito',
  'set.credit': 'Crédito',
  'set.remove': 'Quitar',
  'set.ib.title': 'Balance de apertura',
  'set.ib.startWizard': 'Iniciar el asistente para crear un balance de apertura',
  'set.ib.confirmDate': 'Confirmar la fecha de inicio',
  'set.ib.setUp': 'Configurar el balance de apertura',
  'set.ib.confirmDateInPlumme': 'Confirmar la fecha de inicio en Plumme',
  'set.ib.startDate': 'Fecha de inicio',
  'set.back': 'Volver',
  'set.ib.dateOk': 'La fecha es correcta, continuar',
  'set.ib.draftEmpty': 'El borrador está vacío.',
  'set.text': 'Texto',
  'set.toDebit': 'A (débito)',
  'set.fromCredit': 'De (crédito)',
  'set.editLine': 'Editar línea',
  'set.removeLine': 'Quitar línea',
  'set.quickPick': 'Selección rápida',
  'set.addNewLine': 'Añadir una línea nueva',
  'set.saved': 'Guardado',
  'set.startOver': 'Empezar de nuevo',
  'set.ib.finish': 'Completar el balance de apertura',
  'set.ib.summary': 'Resumen: importes que entran y salen de las cuentas',
  'set.ib.openNote': 'El asiento está abierto y se puede modificar desde esta vista.',
  'set.ib.intoAccount': 'A la cuenta',
  'set.ib.outOfAccount': 'De la cuenta',
  'set.sum': 'Total',
  'set.ib.openEntry': 'Asiento abierto',
  'set.accountNo': 'N.º de cuenta',
  'set.name': 'Nombre',
  'set.vatCode': 'Código de IVA',
  'set.description': 'Descripción',
  'set.relevantLinks': 'Enlaces relevantes',
  'set.deleteCancel': 'Eliminar / cancelar',
  'set.ib.edit': 'Editar el balance de apertura',
  'set.ib.openingForAccount': 'Saldo de apertura de la cuenta',
  'set.cancel': 'Cancelar',
  'set.save': 'Guardar',
  'set.ib.postDescription': 'Descripción del asiento',
  'set.pickAccount': 'Elegir cuenta ...',
  'set.accountDebit': 'Cuenta (débito)',
  'set.ib.cannotBeEmpty': 'Un balance de apertura no puede estar vacío',
  'set.continueTitle': '¿Continuar?',
  'set.ib.post': 'Contabilizar el balance de apertura',
  'set.ib.draftTitle': 'Borrador del balance de apertura',
  'set.ib.draftHelp': 'Introduce las cifras del balance de tu sistema anterior para que el balance de comprobación empiece correctamente en Plumme.',
  'set.noteOptional': 'Nota (opcional)',
  'set.notePh': 'Por ejemplo, qué se importó y desde qué fecha',
  'set.ib.lines': 'Líneas de balance',
  'set.ib.linesHelp': 'Las cifras del balance en la fecha de transición, desglosadas por cuenta: activos, patrimonio y pasivos del sistema anterior. Introduce una línea por cuenta para que el balance empiece con las cifras correctas en Plumme.',
  'set.ib.addLine': 'Añadir línea de balance',
  'set.startup.title': 'Cifras iniciales',
  'set.startup.introText': 'Usa esto si te pasas a Plumme a mitad de {year}. Introduces las cifras de IVA y de la cuenta de resultados de tu sistema anterior, para que los informes y la declaración de impuestos continúen correctamente desde la fecha de transición.',
  'set.startup.startWizard': 'Iniciar el asistente para introducir las cifras iniciales',
  'set.startup.stepDate': 'Fecha de transición e IVA',
  'set.startup.stepLines': 'Ventas y gastos',
  'set.startup.confirmTitle': 'Confirma la fecha de transición y el IVA hasta ahora',
  'set.startup.linesTitle': 'Desglosa las cifras anteriores al {date}',
  'set.startup.save': 'Guardar cifras iniciales',
  'set.startup.receiptTitle': 'Cifras iniciales a {date}',
  'set.startup.receiptSub': 'Guardadas para la transición a Plumme',
  'set.startup.receiptLines': '{lines} líneas registradas: {sales} de ventas y {costs} de gastos.',
  'set.startup.edit': 'Editar cifras iniciales',
  'set.transitionDate': 'Fecha de transición',
  'set.transitionDateHelp': 'La fecha en que te pasaste a Plumme. Las cifras iniciales cubren el periodo desde el comienzo del año hasta esta fecha, llevado en el sistema anterior.',
  'set.outputVatBefore': 'IVA repercutido antes del inicio',
  'set.outputVatBeforeHelp': 'El IVA que ya has cobrado en las ventas en lo que va de año, antes de la transición. Se suma a las cifras de IVA del año para que la declaración de IVA sea correcta.',
  'set.inputVatBefore': 'IVA soportado antes del inicio',
  'set.inputVatBeforeHelp': 'El IVA que ya has pagado en las compras en lo que va de año (y puedes deducir), antes de la transición.',
  'set.salesByAccount': 'Ventas por cuenta',
  'set.salesByAccountHelp': 'Los ingresos por ventas en lo que va de año, desglosados por cuenta de ingresos. Introduce una línea por cuenta de ventas para que la cuenta de resultados empiece con las cifras correctas.',
  'set.salesByAccountBefore': 'Ventas por cuenta antes del inicio',
  'set.addSalesLine': 'Añadir línea de ventas',
  'set.noSalesLines': 'Aún no hay líneas de ventas.',
  'set.costsByAccount': 'Gastos por cuenta',
  'set.costsByAccountHelp': 'Los gastos en lo que va de año, desglosados por cuenta de gastos. Introduce una línea por cuenta de gastos para que el resultado sea correcto desde la fecha de transición.',
  'set.costsByAccountBefore': 'Gastos por cuenta antes del inicio',
  'set.addCostLine': 'Añadir línea de gastos',
  'set.noCostLines': 'Aún no hay líneas de gastos.',
  'set.import.title': 'Importar contabilidad completa',
  'set.import.pickPackage': 'Elegir archivos de exportación',
  'set.import.shouldContain': 'El paquete debe contener',
  'set.import.saft': 'SAF-T Financial XML',
  'set.import.parties': 'Registro de clientes y proveedores, preferiblemente en Excel o CSV',
  'set.import.chart': 'Plan de cuentas',
  'set.import.vouchers': 'Justificantes, recibos y facturas en PDF o imágenes',
  'set.import.bankRecs': 'Conciliaciones bancarias y copias de facturas',
  'set.import.firstStep': 'Primer paso en Plumme',
  'set.import.readsStructure': 'Lee la estructura de los archivos',
  'set.import.findsFiles': 'Encuentra los archivos SAF-T, Excel y de justificantes',
  'set.import.buildsAnalysis': 'Genera un análisis de importación',
  'set.import.letsApprove': 'Te permite aprobar una importación segura del plan de cuentas, clientes, proveedores y balance de apertura',
  'set.import.notAutomatic': 'Aún no es automático',
  'set.import.noPromise': 'Plumme no garantiza que todo sea exactamente idéntico a tu sistema anterior',
  'set.import.noHistoric': 'Los asientos históricos no se contabilizan sin aprobación',
  'set.import.nothingToAltinn': 'No se envía nada a Altinn',
  'set.import.noOverwrite': 'Los justificantes existentes no se eliminan ni se sobrescriben sin confirmación',
  'set.close': 'Cerrar',
  'set.import.approveBase': 'Aprobar la importación de datos base',
  'set.import.working': 'Procesando...',
  'set.import.uploading': 'Subiendo a Firebase Storage',
  'set.import.serverReading': 'El servidor está leyendo ahora los archivos de importación',
  'set.import.importingBase': 'Importando datos base',
  'set.import.savedInAccounts': 'La importación se ha guardado en la contabilidad',
  'set.import.checkBefore': 'Revisa el plan de cuentas, los clientes, los proveedores y el balance de apertura antes de presentar informes.',
  'set.import.dataOnlyTitle': 'Importar solo los datos contables (recomendado)',
  'set.import.dataOnlyHelp': 'Plumme crea en tu navegador una copia filtrada con SAF-T, CSV y Excel. Los PDF, las imágenes y otros documentos no se suben.',
  'set.import.dataOnlyKeepOriginal': 'Conserva el archivo ZIP original de Fiken.',
  'set.import.dataOnlyFiltering': 'Eliminando documentos antes de subir',
  'set.import.dataOnlyFilteringHelp': 'El archivo original no se modifica. Solo se envía a Plumme el nuevo paquete de datos filtrado.',
  'set.import.dataOnlyFiltered': 'Se excluyeron de la subida {count} archivos de documentos y justificantes.',
  'set.import.dataOnlyLibraryFailed': 'No se pudo cargar el filtro ZIP. Inténtalo de nuevo o extrae manualmente los archivos SAF-T, CSV y Excel.',
  'set.import.dataOnlyNoFiles': 'No se encontraron archivos SAF-T, CSV o Excel en el paquete ZIP.',
  'set.import.packages.title': 'Paquetes de importación guardados',
  'set.import.packages.help': 'Consulta todos los archivos ZIP y qué paquete es la fuente activa del archivo de importación.',
  'set.import.packages.loading': 'Cargando paquetes...',
  'set.import.packages.empty': 'No hay archivos ZIP guardados.',
  'set.import.packages.statusImported': 'Importación activa',
  'set.import.packages.statusDuplicate': 'Duplicado idéntico',
  'set.import.packages.statusPrevious': 'Importación anterior',
  'set.import.packages.statusAnalyzed': 'Leído',
  'set.import.packages.statusFailed': 'Error de lectura',
  'set.import.packages.statusAnalyzing': 'Leyendo',
});
